<script>
  import { Progress } from 'element-ui'
  export default {
    name:'ElProgress',
    extends:Progress
  }
</script>
